"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgCheckAllSuccess = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  "data-name": "Regular 1.5px/check_all",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Regular 1.5px/check_all background",
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }, void 0), (0, jsx_runtime_1.jsxs)("g", Object.assign({
    fill: "#10bb69"
  }, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M6.999 16.922a2.745 2.745 0 01-1.804-.672l-.139-.13-2.586-2.59A.75.75 0 013 12.25a.743.743 0 01.446.147l.085.073 2.585 2.586a1.241 1.241 0 00.883.366 1.26 1.26 0 00.321-.042l.136-.044 1.1 1.1a2.735 2.735 0 01-1.557.486zm4.42-3.281l-1.06-1.06L15.47 7.47a.75.75 0 011.06 0 .754.754 0 01.073.976l-.073.085-5.11 5.109z"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Vector 410 (Stroke)",
      d: "M21.53 8.48l-7.635 7.636a2.75 2.75 0 01-3.889 0L7.42 13.53a.75.75 0 011.06-1.06l2.586 2.585a1.25 1.25 0 001.768 0L20.47 7.42a.75.75 0 011.06 1.06z"
    }, void 0)]
  }), void 0)]
}), void 0);

exports.default = SvgCheckAllSuccess;